import React, { useState, useEffect, useMemo } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const WhatsAppButton = ({ message = "¡Hola! Quiero más información" }) => {
  const { t } = useTranslation();
  const [contact_page_data, setContact_page_data] = useState(null);

  useEffect(() => {
    const generalDataBs = localStorage.getItem("generalData");
    if (!generalDataBs) return;

    try {
      const parsedData = JSON.parse(generalDataBs);
      const contactData = parsedData?.[0]?.data?.ecommerce_content?.contact_page || null;
      setContact_page_data(contactData);
    } catch (error) {

    }
  }, []);

  // Helper: solo dígitos y me aseguro de que tenga código de país (507).
  const formatPhoneIntl = (raw) => {
    const digits = (raw || "").replace(/\D/g, "");
    if (!digits) return "";
    // Si comienza con 507 (Panamá) o con otro código (>= 8 dígitos) lo dejo.
    if (digits.startsWith("507")) return digits;
    // Si parece local de 8 dígitos, preprendo 507
    if (digits.length === 8) return `507${digits}`;
    return digits; // ya viene con código de país
  };

  const { phoneIntl, encodedMsg, appUrl, webUrl } = useMemo(() => {
    const phoneIntl = formatPhoneIntl(contact_page_data?.whatsapp_phone);
    const msg = contact_page_data?.whatsapp_message || message;
    const encodedMsg = encodeURIComponent(msg);
    const appUrl = phoneIntl ? `whatsapp://send?phone=${phoneIntl}&text=${encodedMsg}` : "";
    const webUrl = phoneIntl ? `https://wa.me/${phoneIntl}?text=${encodedMsg}` : "";
    return { phoneIntl, encodedMsg, appUrl, webUrl };
  }, [contact_page_data, message]);

  const openWhatsApp = (e) => {
    e.preventDefault();
    if (!phoneIntl) return;

    let appOpened = false;

    // Si el navegador cambia a segundo plano (la app se abrió), cancelamos el fallback
    const handleVisibility = () => {
      if (document.hidden) {
        appOpened = true;
        clearTimeout(fallbackTimer);
        document.removeEventListener("visibilitychange", handleVisibility);
      }
    };
    document.addEventListener("visibilitychange", handleVisibility, { once: true });

    // Intento 1: deep link por location (recomendado en móviles)
    window.location.href = appUrl;

    // Intento 1.1 (extra para algunos iOS/WKWebView): iframe oculto
    const iframeTimer = setTimeout(() => {
      if (!appOpened) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = appUrl;
        document.body.appendChild(iframe);
        setTimeout(() => {
          try { document.body.removeChild(iframe); } catch { }
        }, 2000);
      }
    }, 50);

    // Fallback: abrir WhatsApp Web si la app no respondió
    const fallbackTimer = setTimeout(() => {
      if (!appOpened) {
        window.open(webUrl, "_blank", "noopener,noreferrer");
      }
      clearTimeout(iframeTimer);
      document.removeEventListener("visibilitychange", handleVisibility);
    }, 700);
  };

  const disabled = !phoneIntl;

  return (

    <>

      <div
        className="bq-trigger-fixed"
      >
        {/* ── TRIGGER BUTTON ── */}
        <button
          className="bq-trigger-2"
          onClick={openWhatsApp}
          title={disabled ? t('whatsapp.unavailable') : t('whatsapp.chat')}
        >
          <div className="bq-trigger-icon">
            <FaWhatsapp />
          </div>
          <span className="bq-trigger-label">
            WhatsApp
          </span>
        </button>
      </div>
    </>

  );
};

export default WhatsAppButton;
